import { Fab, Grid, Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { EntityTypes, ProductCategoryDto, ProductGroupDto } from '../../../common/PricePrgClient';
import { RootState } from '../../../store';
import { ProductCategoryRow } from '../ProductCategoryRow';
import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/system';
import { StyledTabs } from '../../../common/StyledComponents';
import { ProductGroupRow } from '../ProductGroupRow';
const mapStateToProps = (state: RootState) => ({
    productCategories: state.product.productCategories,
    productGroups: state.product.productGroups,
    appRestrictions: state.settings.applicationRestrictions
});

type Props = ReturnType<typeof mapStateToProps>;

const ProductCategoriesTab = ({ productCategories, productGroups, appRestrictions }: Props) => {
    const [pCatArr, setPCatArr] = useState([] as ProductCategoryDto[]);
    const [pGroupArr, setPGroupArr] = useState([] as ProductGroupDto[]);
    const isCreateDisabled = appRestrictions[EntityTypes.Product]?.isCreateDisabled ?? true;
    useEffect(() => {
        setPCatArr(Object.values(productCategories));
    }, [productCategories]);

    useEffect(() => {
        setPGroupArr(Object.values(productGroups));
    }, [productGroups]);

    const addNewCategory = () => {
        setPCatArr([...pCatArr, { name: '', productCategoryId: 0, externalIdentifier: '', level: 1 }]);
    };

    const addNewProductGroup = () => {
        setPGroupArr([...pGroupArr, { name: '', productGroupId: 0, externalIdentifier: '' }]);
    };

    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    return (
        <Grid sx={{ flexFlow: 'row' }} container>
            <Grid item xs={9} sx={{ paddingLeft: '10px' }}>
                <StyledTabs
                    value={tabIndex}
                    onChange={(e, idx) => handleTabChange(idx)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Product categories" />
                    <Tab label="Product groups" />
                </StyledTabs>

                <Box p={2}>
                    {tabIndex === 0 && (
                        <>
                            {pCatArr.map(p => (
                                <ProductCategoryRow
                                    key={p.productCategoryId}
                                    productCategory={p}
                                    disabled={isCreateDisabled}
                                />
                            ))}
                            <Fab color="secondary" size="small" onClick={addNewCategory}>
                                <AddIcon />
                            </Fab>
                        </>
                    )}
                    {tabIndex === 1 && (
                        <>
                            {pGroupArr.map(p => (
                                <ProductGroupRow
                                    key={p.productGroupId}
                                    productGroup={p}
                                    disabled={isCreateDisabled}
                                />
                            ))}
                            <Fab
                                color="secondary"
                                size="small"
                                disabled={isCreateDisabled}
                                onClick={addNewProductGroup}
                            >
                                <AddIcon />
                            </Fab>
                        </>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default connect(mapStateToProps)(ProductCategoriesTab);
